import Profile from '../Modulus/Profile/profile'

export default [
    {
        component: Profile,
        path: '/',
    },
];
